import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as types from './constants';
import * as actions from './actions';
import axios from 'utils/axios';
import { makeSelectAuthToken } from 'store/Selector';

function* getVersionSaga() {
  try {
    const token = yield select(makeSelectAuthToken());
    const headers = { headers: { Authorization: `Bearer ${token}` } };
    const response = yield call(axios.get, '/admin/version/getVersion', headers);

    if (response.data && response.data.data && response.data.data.version && response.data.data.version.length > 0) {
      yield put(actions.getVersionSuccess(response.data.data.version[0]));
    } else {
      yield put(actions.getVersionSuccess(null));
    }
  } catch (error) {
    const errorMessage = error.response ? error.response.data.message : 'Something went wrong';
    yield put(actions.getVersionFailure(errorMessage));
  }
}

function* updateVersionSaga(action) {
  try {
    const token = yield select(makeSelectAuthToken());
    const headers = { headers: { Authorization: `Bearer ${token}` } };
    const response = yield call(axios.patch, '/admin/version/updateversion', action.payload, headers);

    if (response.data && response.data.data && response.data.data.version) {
      yield put(actions.updateVersionSuccess(response.data.data.version));
    } else {
      yield put(actions.getVersionRequest());
    }
  } catch (error) {
    const errorMessage = error.response ? error.response.data.message : 'Update failed';
    yield put(actions.updateVersionFailure(errorMessage));
  }
}

export default function* versionSaga() {
  yield takeLatest(types.GET_VERSION_REQUEST, getVersionSaga);
  yield takeLatest(types.UPDATE_VERSION_REQUEST, updateVersionSaga);
}
